import { Camera } from "../render/Camera";
import type { Demo, Scene } from "./types";
import { makeWorld, floor, walls, box, ball, rng } from "./helpers";

export const sandbox: Demo = {
	id: "sandbox",
	title: "Throw sandbox",
	blurb:
		"Your playground. Click to drop a shape, or press and drag to fling one — flick of the wrist physics.",
	category: "Playground & Toys",
	build(): Scene {
		const world = makeWorld();
		floor(world, 24);
		walls(world, 10, 16);

		const random = rng(0x5a2d2026);

		let downX = 0;
		let downY = 0;
		let dragging = false;

		const spawn = (x: number, y: number, vx: number, vy: number): void => {
			if (random() < 0.5) {
				ball(world, x, y, 0.4 + random() * 0.35, {
					restitution: 0.35,
					friction: 0.3,
					velocity: [vx, vy],
				});
			} else {
				const s = 0.6 + random() * 0.5;
				box(world, x, y, s, s, {
					angle: random() * Math.PI,
					restitution: 0.2,
					friction: 0.4,
					velocity: [vx, vy],
					angularVelocity: (random() - 0.5) * 6,
				});
			}
		};

		return {
			world,
			camera: new Camera(0, -3, 26),
			hint: "Click to drop · press &amp; drag to throw",
			onPointerDown(x, y): void {
				downX = x;
				downY = y;
				dragging = true;
			},
			onPointerUp(x, y): void {
				if (!dragging) return;
				dragging = false;
				// Velocity points from press → release (a slingshot feel).
				const vx = (x - downX) * 3;
				const vy = (y - downY) * 3;
				spawn(downX, downY, vx, vy);
			},
		};
	},
};
